/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Stuck_CheckingInputs */

const vi_einvoice_stuck_checking = /** @type {(inputs: Einvoice_Stuck_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang kiểm tra với MISA…`)
};

/**

* @param {Einvoice_Stuck_CheckingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_stuck_checking = /** @type {((inputs?: Einvoice_Stuck_CheckingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Stuck_CheckingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_stuck_checking(inputs)
});